import { createUuid } from '@app/utilities';
import OldInput from "../OldInput";
import Dropdown from "../Dropdown";
import Button from "../Button";
import ReturnSubCon from "./ReturnSubCon";
import { Constant } from '../../const';

export default class ModuleReturnSubCon extends ReturnSubCon {
    /**
     * Submenu view for tabular router node output
     * @module ModuleReturnSubCon
     * @param {Object} props React props
     */
    constructor(props){
        super(props);
    }

    /**
     * Initialize dummy data model
     * @returns {Object}
     */
    initVarModel(){
        return {
            argumentName: null,
            id: createUuid(),
            varName: null,
            type: null,
        };
    }

    isValidModel(){
        return this.varModel.argumentName && this.varModel.varName && (this.varModel.type || this.knownType);
    }

    /**
     * React render
     * @returns {XML}
     */
    render() {
        var options = [{name: "* Module output", value: "out"}];
        if (this.props.params.ref){
            const refNode = window.apm.getNode(this.props.params.ref.split("::")[0]);
            if (refNode && refNode.localVariables){
                for (var i = 0; i < refNode.localVariables.length; i++){
                    options.push({
                        name: refNode.localVariables[i].props.config.varName,
                        value: Constant.k.SCOPE_MODULE + "." + refNode.localVariables[i].props.config.varName
                    });
                }
            }
        }
        const locSelection = window.apm.knowledgeBase.getIndexFromValue(this.varModel.argumentName, options);
        const preSelection = window.apm.knowledgeBase.getVariableTypeIndexFromValue(this.varModel.type);

        return (
            <div>
                {<Dropdown 
                    context={this} 
                    label={this.getPropLabel("module_argument_name")} 
                    optionName={this.getPropLabel("select_variable")}
                    options={options} valKey={"argumentName"}
                    selection={locSelection}
                    suppressUpdate={true}
                    />
                }

                {<OldInput 
                    label={this.getPropLabel("return_value_to")} 
                    hint={this.getPropLabel("scoped_variable_name_hint")} 
                    value={this.varModel.varName} 
                    valRules={{ "noEmpty": true, "varName": true }}
                    context={this} 
                    valKey={"varName"} 
                    suggestion={"variable"}
                    suppressUpdate={true}
                    />
                }

                {!this.knownType && this.varScope!=="mod"&&
                    <Dropdown 
                        wide={true} 
                        label={this.getPropLabel("variable_type")} 
                        optionName={this.getPropLabel("type_opt")}
                        options={window.apm.knowledgeBase.getVariableTypes()}
                        context={this} 
                        valKey={"type"}
                        selection={preSelection} 
                        suppressUpdate={true}
                    />
                }
                
                {(() => {
                    if (this.isKnownModel()) {
                        // Display edit and delete for editing
                        return (
                            <table style={{width: "100%"}}><tbody><tr>
                                <td style={{paddingRight: "2px"}}>
                                    {<Button icon={"icon-trash"} tint={"warning"}
                                        callback={() => {
                                            this.remove();
                                        }}
                                    />}
                                </td>
                                <td>
                                    {<Button 
                                        label={this.getPropLabel("save_output")} 
                                        wide={true}
                                        callback={() => {
                                            this.update();
                                        }}
                                    />}
                                </td>
                            </tr></tbody></table>
                        );
                    }
                    if (!this.isKnownModel()) {
                        return (
                            <Button 
                                label={this.getPropLabel("add_output")} 
                                wide={true}
                                callback={() => {
                                    if (this.isValidModel()) {
                                        this.add();
                                    }
                                    this.props.domContext.removeSubmenu();
                                }}
                            />
                        );
                    }
                })()}
            </div>
        );
    }
}